import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './patientQueue.scss';
import { fetchDoctorById, fetchTokensForPatients, fetchDoctorProfileImage } from '../../../api/etokenService';
import PatientQueueList from '../patientQueueList/patientQueueList';
import Notification from '../notification/notification';


const PatientQueue = ({ doctorId, clinicId }) => {
    const [doctorData, setDoctorData] = useState(null);
    const [imageUrl, setImageUrl] = useState('');
    const [patients, setPatients] = useState([]);
    const [inProgressPatient, setInProgressPatient] = useState(null);


    // Fetch doctor data once on mount or when doctorId/clinicId changes
    useEffect(() => {
        const getDoctorData = async () => {
            try {
                const data = await fetchDoctorById(doctorId);
                setDoctorData(data.doctors ? data.doctors[0] : null);
                const imgUrl = await fetchDoctorProfileImage(doctorId);
                setImageUrl(imgUrl);
            } catch (error) {
                console.error("Error fetching doctor data:", error);
            }
        };
        getDoctorData();
    }, [doctorId, clinicId]);

    // Poll patients data every 3 seconds
    useEffect(() => {
        let isMounted = true;
        let intervalId;

        const getPatientsData = async () => {
            try {
                const data = await fetchTokensForPatients(doctorId, clinicId);
                if (isMounted) {
                     setPatients(data.tokens || []);
                    // Find the first patient with status 'In Progress'
                    const inProgress = (data.tokens || []).find(
                        (p) => p.status === 'In Progress'
                    );
                    setInProgressPatient(inProgress || null);
                }
            } catch (err) {
                if (isMounted) {
                    setPatients([]);
                    setInProgressPatient(null);
                }
            }
        };

        if (doctorId && clinicId) {
            getPatientsData();
            intervalId = setInterval(getPatientsData, 3000);
        }

        return () => {
            isMounted = false;
            if (intervalId) clearInterval(intervalId);
        };
    }, [doctorId, clinicId]);

    return (
        <div className="container" style={{ position: 'relative' }}>
            <h4 className="mb-2 mt-2 text-center w-100">Patient Queue</h4>
            {/* <div className="card-body"> */}
            <div className="border pt-2 row header-top">
                <div className='col-4 col-md-1 text-start'>
                    <img
                        src={imageUrl || "/doctor.jpg"}
                        alt="Doctor"
                        className="rounded profile-image"
                    />
                </div>
                <div className="text-start col-6 col-md-3 header-details-1">
                    <h5 className="mb-1 fw-bold">{doctorData ? doctorData.first_name + ' ' + doctorData.last_name : 'Loading...'}</h5>
                    <div>{doctorData ? doctorData.qualification : 'Loading...'}</div>
                </div>
                <div className="text-start col-md-7 header-details-2 d-none d-md-block">
                    <div>
                        <span className="label-fixed-width">Specialization:</span>
                        {doctorData ? doctorData.specialization : 'Loading...'}
                    </div>
                    <div>
                        <span className="label-fixed-width">Experience:</span>
                        {doctorData?.experience_years}+ Years
                    </div>
                    <div>
                        <span className="label-fixed-width">Mobile #:</span>
                        {doctorData?.phone_number}
                    </div>
                </div>
            </div>

            <PatientQueueList patients={patients} />
            {/* </div> */}

            <div className="card-footer text-center text-muted small">
                © 2025 Designed & Developed by OVA2 Consultants Pvt. Ltd.
            </div>

            {/* Notification in bottom right */}
            <Notification inProgressPatient={inProgressPatient} doctorId={doctorId} />
        </div>
    );
};

export default PatientQueue;
